import * as types from "../types";
import * as oaApi from "../../http/oaApi";
import * as publicApi from "../../http/publicApi";
const state = {
    isCollapse: false,

    systemTime: "",
    systemDate: "",

    priorityList: "", // 优先级列表
    statusList: "", //状态列表
    education: "", // 学历列表

    staffList: "", // 员工下拉列表
    roleList: "", // 角色列表

    departUserList: [],

    screenWidth: document.body.clientWidth, // 屏幕宽
    screeHeight: document.body.clientHeight, // 屏幕高

    orderDrawerVisible: false, //orderDrawer visible

    wwwUrl: process.env.VUE_APP_WWW_URL,

    setting: {
        menubar: false,
        toolbar:
            "fontselect | fontsizeselect | forecolor backcolor | bold italic underline strikethrough | image | link unlink | undo redo | formatselect alignleft aligncenter alignright alignjustify | numlist bullist | table | indent outdent | superscript subscript | paste | removeformat |",
        toolbar_drawer: "sliding",
        quickbars_selection_toolbar:
            "removeformat | bold italic underline strikethrough | fontsizeselect forecolor backcolor",
        plugins: "link image media table lists fullscreen paste",
        language: "zh_CN", //本地化设置
        height: 320,
        auto_focus: false,
        branding: false,
        link_title: false, //设置插入超链接对话框中“标题”的显示开关
        default_link_target: "_blank", //链接默认打开方式
        fontsize_formats: "11px 12px 14px 16px 18px 24px 36px 48px",
        content_style: "p {font-size:13px}",
        resize: false,
        paste_word_import: "merge", // 是否保留word粘贴样式  clean | merge
        paste_data_images: true,
        images_file_types: "jpeg,jpg,png,gif,bmp,webp",
        images_upload_handler: function(blobInfo, succFun, failFun) {
            const formData = new FormData();
            formData.append("img", blobInfo.blob());
            publicApi.uploadImg(formData, "post").then(res => {
                if (res) {
                    succFun(res.data);
                } else {
                    failFun("上传失败");
                }
            });
        }
    },
    // el 时间控件的配置项
    pickerOptions: {
        disabledDate(time) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24;
        }
    },
    departSelectUser: [],
    screen: `calc(100% - 44px - 40px - 40px)`,
    is_infoTags: 'normal'
};

const mutations = {
    [types.INDEX_COLLAPSE](state, status) {
        state.isCollapse = status;
    },

    [types.SYSTEM_TIME](state, status) {
        state.systemTime = status.sysdate2;
    },
    [types.SYSTEM_DATE](state, status) {
        state.systemDate = status.sysdate;
    },

    [types.PRIORITY_LIST](state, status) {
        state.priorityList = [...status];
    },
    [types.STATUS_LIST](state, status) {
        state.statusList = status;
    },
    [types.EDUCATION_LIST](state, status) {
        state.education = status;
    },

    [types.STAFF_LIST](state, status) {
        state.staffList = status;
    },
    [types.MSG_LIST](state, status) {
        state.msgList = status;
    },
    [types.ROLE_LIST](state, status) {
        state.roleList = status;
    },
    [types.INDEX_ORDERDRAWERVISIBLE](state, status) {
        state.orderDrawerVisible = status;
    },
    [types.WWWURL](state, status) {
        state.wwwUrl = status;
    },
    [types.DEPART_USER_LIST](state, status) {
        state.departUserList = status;
    },
    [types.DEPART_SELECT_USER](state, status) {
        state.departSelectUser = status;
    },
    [types.IS_INFOTAGS] (state,status) {
        state.is_infoTags = status;
    },
};

const getters = {};

const actions = {
    gconf({ commit, dispatch }, nameVal) {
        oaApi
            .gconf(
                {
                    name: nameVal
                },
                "get"
            )
            .then(res => {
                if (res) {
                    if (nameVal == "priority") {
                        commit("PRIORITY_LIST", res.data);
                    } else if (nameVal == "education") {
                        commit("EDUCATION_LIST", res.data);
                    }
                }
            });
    },
    getSysDate({ commit, dispatch }) {
        oaApi.getSysDate().then(res => {
            if (res) {
                commit("SYSTEM_TIME", res.bus_json);
                commit("SYSTEM_DATE", res.bus_json);
            }
        });
    },

    getStaffSelect({ commit, dispatch }) {
        oaApi.select({}, "get").then(res => {
            if (res) {
                commit("STAFF_LIST", res.data);
            }
        });
    },
    getRoleList({ commit, dispatch }) {
        oaApi.role({}, "get").then(res => {
            if (res) {
                commit("ROLE_LIST", res.data);
            }
        });
    },
    getDepartUser({ commit, dispatch }) {
        oaApi.departUser({}, "get").then(res => {
            if (res) {
                commit("DEPART_USER_LIST", res.data);
            }
        });
    },
    getDepartSelectUser({ commit, dispatch }, payload) {
        oaApi.getDepartSelectUser(payload, "get").then(res => {
            if (res) {
                commit("DEPART_SELECT_USER", res.data);
            }
        });
    }
};

export default {
    state,
    actions,
    getters,
    mutations
};
